package com.eladfinish.bible.contest.screens.chapterComplete.features.progressiveExposure

import kotlinx.collections.immutable.ImmutableList

/**
 * Small helpers to keep the renderer readable.
 */
internal object ProgressiveExposureSelectors {

    data class SegmentLocation(
        val verseIndex: Int,
        val partIndexInVerse: Int, // 0..(partsCount-1)
    )

    /**
     * Maps a global segment index to:
     * - verseIndex
     * - partIndexInVerse (within that verse)
     *
     * verseStartSegments is a prefix-sum array/list:
     * size = versesCount + 1
     * verseStartSegments[last] = elementsNumber
     */
    fun locate(
        verseStartSegments: ImmutableList<Int>,
        currentSegment: Int,
    ): SegmentLocation {
        var low = 0
        var high = verseStartSegments.size - 2 // last is end marker

        while (low <= high) {
            val mid = (low + high) ushr 1
            val start = verseStartSegments[mid]
            val next = verseStartSegments[mid + 1]

            if (currentSegment < start) {
                high = mid - 1
            } else if (currentSegment >= next) {
                low = mid + 1
            } else {
                return SegmentLocation(
                    verseIndex = mid,
                    partIndexInVerse = currentSegment - start,
                )
            }
        }

        // Should never happen if currentSegment is valid.
        return SegmentLocation(
            verseIndex = 0,
            partIndexInVerse = 0,
        )
    }
}
